const DAYS = [
  { d: "Mon", h: "62%", open: true },
  { d: "Tue", h: "80%", open: true },
  { d: "Wed", h: "50%", open: true, sky: true },
  { d: "Thu", h: "72%", open: true },
  { d: "Fri", h: "20%", open: false },
  { d: "Sat", h: "12%", open: false },
  { d: "Sun", h: "12%", open: false },
];

export function LandingAvailability() {
  return (
    <section style={{ padding: "var(--lp-sec-y) 0" }}>
      <div className="lp-container">
        <span className="lp-eyebrow" data-reveal>Your week, at a glance</span>
        <h2 className="lp-h1" data-reveal style={{ marginTop: 12, marginBottom: 24 }}>
          Availability that <em>breathes with you.</em>
        </h2>
        <div
          data-reveal
          style={{
            background: "var(--lp-cream)",
            border: "1px solid var(--lp-border)",
            borderRadius: "var(--lp-radius-lg)",
            boxShadow: "var(--lp-shadow-card)",
            padding: 30,
          }}
        >
          <div
            data-reveal-group
            style={{ display: "grid", gridTemplateColumns: "repeat(7, 1fr)", gap: 14, alignItems: "end", height: 200 }}
          >
            {DAYS.map((day) => (
              <div key={day.d} style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 10, height: "100%", justifyContent: "flex-end" }}>
                <span
                  data-reveal="grow"
                  style={{
                    width: "100%",
                    height: day.h,
                    borderRadius: "12px 12px 6px 6px",
                    transformOrigin: "bottom",
                    background: day.open ? (day.sky ? "var(--lp-sky-soft)" : "var(--lp-lilac-soft)") : "var(--lp-ivory-2)",
                    border: day.open
                      ? `1px solid ${day.sky ? "var(--lp-sky)" : "var(--lp-lilac)"}`
                      : "1px dashed var(--lp-border-strong)",
                  }}
                />
                <span style={{ fontFamily: "var(--lp-mono)", fontSize: 11, color: "var(--lp-plum-300)" }}>{day.d}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
